module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }